import React, { useState, useEffect } from "react";
import Select, { ActionMeta, SingleValue } from "react-select";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { User } from "../models/User";
import { getApi } from "@beeldit/core/helpers/api";

interface Option {
  label: string;
  value: number | string;
}

function CustomSelectWidget(props: any) {
  const { id, value, required, disabled, readonly, onChange, placeholder } = props;
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [options, setOptions] = useState<Option[]>([]);
  const [elementsData, setElementsData] = useState({ elements: [] });

  const errorHandler = useErrorHandler();
  const index = () => {
    getApi()
      .get(`/users`)
      .then((response) => {
        setElementsData(response.data);
      })
      .catch((error) => {
        errorHandler(error, null);
      });
  };

  useEffect(() => {
    index();
  }, []);

  useEffect(() => {
    const options = elementsData.elements.map((user: User) => {
      return { label: user.name + " " + user.surname, value: user.id };
    });
    setOptions(options);
    const currentSelectedOption = options.find(
      (option) => option.value === value
    );
    setSelectedOption(currentSelectedOption || null);
  }, [elementsData, value]);

  const handleOnChange = (
    newValue: SingleValue<Option>,
    actionMeta: ActionMeta<Option>
  ) => {
    const selectedOption = newValue as Option | null;
    setSelectedOption(selectedOption);
    const model = selectedOption?.value ?? null;
    onChange(model);
  };

  const selectStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: "#E7F5F2",
      backgroundColor: "#E7F5F2",
      borderRadius: "0.25rem",
    }),
  };

  return (
    <Select
      id={id}
      options={options}
      value={selectedOption}
      required={required}
      isDisabled={disabled || readonly}
      onChange={handleOnChange}
      styles={selectStyles}
      placeholder={placeholder}
      isClearable={true}
    />
  );
}

function UserSelector(props: any) {
  const { id, options, value, required, disabled, readonly, onChange, placeholder } = props;
  return (
    <CustomSelectWidget
      id={id}
      options={options.enumOptions}
      placeholder={placeholder}
      value={value}
      required={required}
      disabled={disabled}
      readonly={readonly}
      onChange={onChange}
    />
  );
}

export default UserSelector;
